import { formatDateToIsoString } from "@/helpers/helpers";

export default {
  requestQueryParams() {
    const params = new URLSearchParams();

    if (
      this.filters.advanced.name !== "" &&
      this.filters.advanced.name != null
    ) {
      params.set("name", this.filters.advanced.name);
    }

    if (this.filters.advanced.jobFoundMethod != null) {
      params.set("jobFoundMethod", this.filters.advanced.jobFoundMethod);
    }

    if (this.filters.advanced.didOdysseaSupport != null) {
      params.set("didOdysseaSupport", this.filters.advanced.didOdysseaSupport);
    }

    if (this.filters.advanced.branch != null) {
      params.set("branch", this.filters.advanced.branch);
    }

    if (this.filters.advanced.employerName != null) {
      params.set("employerName", this.filters.advanced.employerName);
    }

    if (this.filters.advanced.partOfNetwork != null) {
      params.set("partOfNetwork", this.filters.advanced.partOfNetwork);
    }

    if (this.filters.advanced.fieldOfEmployment != null) {
      params.set("fieldOfEmployment", this.filters.advanced.fieldOfEmployment);
    }

    if (this.filters.advanced.jobTitleId != null) {
      params.set("jobTitleId", this.filters.advanced.jobTitleId);
    }

    if (this.filters.advanced.typeOfEmployment != null) {
      params.set("typeOfEmployment", this.filters.advanced.typeOfEmployment);
    }

    if (this.filters.advanced.durationOfContract != null) {
      params.set(
        "durationOfContract",
        this.filters.advanced.durationOfContract
      );
    }

    if (
      this.filters.advanced.dateDates != null &&
      this.filters.advanced.dateDates.length > 0
    ) {
      const dateStartDate = this.filters.advanced.dateDates[0];
      const dateEndDate = this.filters.advanced.dateDates.at(-1);
      params.set("dateStartDate", formatDateToIsoString(new Date(dateStartDate)));
      params.set("dateEndDate", formatDateToIsoString(new Date(dateEndDate)));
    }

    if (
      this.filters.advanced.startDates != null &&
      this.filters.advanced.startDates.length > 0
    ) {
      const stStartDate = this.filters.advanced.startDates[0];
      const stEndDate = this.filters.advanced.startDates.at(-1);
      params.set("stStartDate", formatDateToIsoString(new Date(stStartDate)));
      params.set("stEndDate", formatDateToIsoString(new Date(stEndDate)));
    }

    if (
      this.filters.advanced.endDates != null &&
      this.filters.advanced.endDates.length > 0
    ) {
      const enStartDate = this.filters.advanced.endDates[0];
      const enEndDate = this.filters.advanced.endDates.at(-1);
      params.set("enStartDate", formatDateToIsoString(new Date(enStartDate)));
      params.set("enEndDate", formatDateToIsoString(new Date(enEndDate)));
    }

    if (this.filters.advanced.netSalaryRange?.length > 0) {
      this.filters.advanced.netSalaryRange.forEach((element) =>
        params.append("netSalaryRange", element)
      );
    }

    if (this.filters.advanced.socialSecurity != null) {
      params.set("socialSecurity", this.filters.advanced.socialSecurity);
    }

    if (this.filters.advanced.jobSatisfactionLevel != null) {
      params.set(
        "jobSatisfactionLevel",
        this.filters.advanced.jobSatisfactionLevel
      );
    }

    if (this.filters.advanced.helpsGrow != null) {
      params.set("helpsGrow", this.filters.advanced.helpsGrow);
    }

    if (this.filters.advanced.feelSecureInJob != null) {
      params.set("feelSecureInJob", this.filters.advanced.feelSecureInJob);
    }

    if (this.filters.advanced.getAlong != null) {
      params.set("getAlong", this.filters.advanced.getAlong);
    }

    if (this.filters.advanced.jobMatchSkills != null) {
      params.set("jobMatchSkills", this.filters.advanced.jobMatchSkills);
    }

    if (this.filters.advanced.recommendEmployer != null) {
      params.set("recommendEmployer", this.filters.advanced.recommendEmployer);
    }

    if (this.filters.advanced.stillLookingForJob != null) {
      params.set(
        "stillLookingForJob",
        this.filters.advanced.stillLookingForJob
      );
    }

    if (this.filters.advanced.newJobLookingFor?.length > 0) {
      this.filters.advanced.newJobLookingFor.forEach((element) =>
        params.append("newJobLookingFor", element)
      );
    }

    if (this.filters.advanced.intakeProjects?.length > 0) {
      this.filters.advanced.intakeProjects.forEach((element) =>
        params.append("intakeProjects", element)
      );
    }

    return params;
  },
};
